import { CurrentUserModel } from './../../../models/account-ledger.model';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
import { CommonService } from '../../../services/common.service';
// tslint:disable-next-line:import-blacklist
import { Subscription, Subject } from 'rxjs';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { CheckoutViewModel, EndUserModel, CheckoutStatusModel, GetEndUserAddressBookOutput } from '../../../models/check-out.model';
import { closeAddrBook, goNext } from '../../../shared/JavaScript/paymentform';
import { ApiResponse } from '../../../models/api-response.model';
import { FormGroup, FormControl } from '@angular/forms';
import { AccountDeliveryAddress, PostcodeList, SuburbList } from '../../../models/account-delivery-address';
import { StateModel } from '../../../models/account-ledger.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { DOCUMENT } from '@angular/common';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../../../services/ngProgress.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-end-user',
  templateUrl: './end-user.component.html',
  styleUrls: ['./end-user.component.css']
})
export class EndUserComponent implements OnInit, OnDestroy {

  cartId: string;
  subscriptionRoute: Subscription;
  shippingAddressModel: ShippingAddressViewModel;
  checkoutViewModel: CheckoutViewModel;
  title = 'End User Information';
  endUserModel: EndUserModel;
  salesType = '';
  popupHtml: string;
  formData: any;
  response: ApiResponse;
  setFullWindow = false;
  loadContent = false;
  addressFormGroup: FormGroup;
  cartName: string;
  selectedAddress: AccountDeliveryAddress;
  checkoutStatus: CheckoutStatusModel;
  selectEndUser: GetEndUserAddressBookOutput;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  stateList: string[];
  /* filteredPostCode: SuburbList[];
  filteredSub: SuburbList[]; */
  filteredPostCodeFromAPI: PostcodeList[];
  filteredSubFromAPI:PostcodeList[];
  salesTypeArray: string[];
  salesTypeArrayFilter: string[];
  templateArray: string[];
  salesTypeDescription: string[];
  salesTypeDescriptionFilter: string[];
  addressIsEdited = false;
  showCopyFromShippingDetails = true;

  companyNameBool: boolean;
  addressBool: boolean;
  suburbBool: boolean;
  stateBool: boolean;
  postcodeBool: boolean;
  phoneBool: boolean;
  countryBool: boolean;
  emailBool: boolean;
  statePlaceHolder: string;

  contactNameBool: boolean;
  emailN: boolean;
  companyNameN: boolean;
  addressN: boolean;
  suburbN:boolean;
  stateN:boolean;
  postcodeN:boolean;
  phoneN:boolean;
  countryN:boolean;
  contactNameN:boolean;
  currentUserModel: CurrentUserModel;

  serial: string;

  showEndUserTab: boolean = true;

  loadSalesType: boolean = false;

  
  backto: string;

  quoteId: string;

  account_validation_messages: any = {
    'out_company_name': [
      { class: 'companyNameValidate', message: 'Please enter company name' }
    ],
    'out_address_1': [
      { class: 'addressLine1Validate', message: 'Please enter address' }
    ],
    'out_suburb': [
      { class: 'suburbValidate', message: 'Please enter suburb' }
    ],
    'out_state': [
      { class: 'stateValidate', message: 'Please enter state' }
    ],
    'out_postcode': [
      { class: 'postcodeValidate', message: 'Please enter postcode' }
    ],
    'out_email': [
      { class: 'emailValidate', message: 'Please enter email' }
    ],
    'out_country': [
      { class: 'countryValidate', message: 'Please enter country' }
    ],
    'out_phone': [
      { class: 'phoneValidate', message: 'Please enter phone number' }
    ],
    'out_display_name': [
      { class: 'contactValidate', message: 'Please enter contact name' }
    ]
  };
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService
    , private commonService: CommonService
    , private shoppingCartService: ShoppingCartService
    , private authService: AuthService
    , public ngProgress: NgProgressService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.addressFormGroup = new FormGroup({
      out_company_name: new FormControl('', []),
      out_address_1: new FormControl('', []),
      out_address_2: new FormControl('', []),
      out_address_3: new FormControl('', []),
      out_suburb: new FormControl('', []),
      out_state: new FormControl('', []),
      out_postcode: new FormControl('', []),
      out_display_name: new FormControl('', []),
      out_phone: new FormControl('', []),
      out_country: new FormControl('', []),
      out_email: new FormControl('', []),
    });
  }

  ngOnInit() {
    
    this.loadContent = false;
    this.companyNameBool = false;
    this.addressBool = false;
    this.suburbBool = false;
    this.stateBool = false;
    this.postcodeBool = false;
    this.phoneBool = false;
    this.countryBool = false;
    this.emailBool = false;
    this.contactNameBool = false;
    this.statePlaceHolder = 'State';
    this.ngProgress.done();
    this.addressIsEdited = false;
    this.emailN = false;
    this.companyNameN=false;
    this.addressN=false;
    this.suburbN=false;
    this.stateN=false;
    this.postcodeN=false;
    this.phoneN=false;
    this.countryN=false;
    this.contactNameN=false;
    this.subscriptionRoute = this.activatedRoute.parent.url
      .subscribe(value => {
        this.cartId = value.length > 1 ? value[1].path : '';
        this.cartName = value.length > 1 ? value[2].path : '';
      },
        (error: any) => {
          console.error(error);
        });

    this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
      this.currentUserModel = model;
    });

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
      });

    this.checkOutService.currentCheckoutViewModel.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CheckoutViewModel) => {
      if(!this.commonService.isEmpty(res)) {
        this.checkoutViewModel = res;
       
        if (this.checkoutViewModel.firstStep === 'ENDUSER') {
          this.showCopyFromShippingDetails = false;
          if (this.checkoutViewModel.tenantDetailsRequired === 'NO') {
            this.checkoutStatus = {
              currentStep: 'ENDUSER',
              firstStep: this.checkoutViewModel.firstStep,
              collectOrder: false,
              hasChosenCheckout: true,
              tenantDetailsRequired: 'NO'
            };
          } else {
            this.checkoutStatus = {
              currentStep: 'ENDUSER',
              firstStep: this.checkoutViewModel.firstStep,
              collectOrder: false,
              hasChosenCheckout: true,
              tenantDetailsRequired: 'YES'
            };
          }
          this.checkOutService.emitChange(this.checkoutStatus);
        }
        
        this.checkOutService.passModelWatch.subscribe((shipModel: ShippingAddressViewModel) => {
          this.shippingAddressModel = shipModel;
          this.checkOutService.selectEndUserWatch.subscribe((response: GetEndUserAddressBookOutput) => {
            if (!this.commonService.isEmpty(response)) {
              this.selectEndUser = response;
              debugger;
              this.addressFormGroup.get('out_company_name').setValue(this.selectEndUser.out_company_name);            
              this.addressFormGroup.get('out_address_1').setValue(this.selectEndUser.out_address_1);
              this.addressFormGroup.get('out_address_2').setValue(this.selectEndUser.out_address_2);
              this.addressFormGroup.get('out_address_3').setValue(this.selectEndUser.out_address_3);                         
              this.addressFormGroup.get('out_suburb').setValue(this.selectEndUser.out_suburb);
              this.addressFormGroup.get('out_state').setValue(this.selectEndUser.out_state);
              this.addressFormGroup.get('out_postcode').setValue(this.selectEndUser.out_postcode);
              this.addressFormGroup.get('out_country').setValue(this.selectEndUser.out_country);
              this.addressFormGroup.get('out_email').setValue(this.selectEndUser.out_email);
              this.addressFormGroup.get('out_phone').setValue(this.selectEndUser.out_phone);
              this.addressIsEdited = true;
            }
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });

        this.loadContent = false;
       
        this.checkOutService.GetEndUser(this.commonService.toNumber(this.cartId), this.checkoutViewModel.firstStep, this.checkoutViewModel.kitProgramTypeList).pipe(takeUntil(this.ngUnsubscribe)).subscribe((getEndUser: EndUserModel) => {
          this.endUserModel = getEndUser;
          this.salesTypeArray = this.endUserModel.salesTypeTab;
          this.salesTypeArrayFilter = this.salesTypeArray;
          this.templateArray = this.endUserModel.endUserTemplate;
        
          if ((this.templateArray.filter(x => x.includes('required out_company_name')).length && this.templateArray.filter(x => x.includes('optional out_company_name')).length) ||
              (this.templateArray.filter(x => x.includes('required out_company_name')).length)){
                this.companyNameBool = true;      
           }           
           else if(this.templateArray.filter(x => x.includes('NoShow out_company_name')).length){
                this.companyNameN = true;
            }                
          
          if ((this.templateArray.filter(x => x.includes('required out_address_1')).length && this.templateArray.filter(x => x.includes('optional out_address_1')).length)|| 
              (this.templateArray.filter(x => x.includes('required out_address_1')).length)){
                this.addressBool = true;            
          }         
          else if(this.templateArray.filter(x => x.includes('NoShow out_address_1')).length)
          {
              this.addressN = true; 
          }
          if ((this.templateArray.filter(x => x.includes('required out_suburb')).length && this.templateArray.filter(x => x.includes('optional out_suburb')).length) ||
              (this.templateArray.filter(x => x.includes('required out_suburb')).length)) {
                  this.suburbBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_suburb')).length)
          {
              this.suburbN=true;
          }
          if ((this.templateArray.filter(x => x.includes('required out_state')).length && this.templateArray.filter(x => x.includes('optional out_state')).length)||
              (this.templateArray.filter(x => x.includes('required out_state')).length)){
                this.stateBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_state')).length)
          {
              this.stateN=true;
          }
          if ((this.templateArray.filter(x => x.includes('required out_postcode')).length && this.templateArray.filter(x => x.includes('optional out_postcode')).length) ||
              (this.templateArray.filter(x => x.includes('required out_postcode')).length)) {
                this.postcodeBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_postcode')).length)
          {
              this.postcodeN=true;
          }
          if ((this.templateArray.filter(x => x.includes('required out_phone')).length && this.templateArray.filter(x => x.includes('optional out_phone')).length)||
              (this.templateArray.filter(x => x.includes('required out_phone')).length)) {
                this.phoneBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_phone')).length)
          {
              this.phoneN=true;
          }
          if ((this.templateArray.filter(x => x.includes('required out_email')).length && this.templateArray.filter(x => x.includes('optional out_email')) .length) ||
              (this.templateArray.filter(x => x.includes('required out_email')).length)){
              this.emailBool = true;
            }         
            else if(this.templateArray.filter(x => x.includes('NoShow out_email')).length){
            this.emailN = true;
            }
                      
          if ((this.templateArray.filter(x => x.includes('required out_country')).length && this.templateArray.filter(x => x.includes('optional out_country')).length)||
              (this.templateArray.filter(x => x.includes('required out_country')).length)) {
                this.countryBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_country')).length)
          {
            this.countryN=true;
          }
          if ((this.templateArray.filter(x => x.includes('required out_display_name')).length && this.templateArray.filter(x => x.includes('optional out_display_name')).length) ||
          (this.templateArray.filter(x => x.includes('required out_display_name')).length)){
            this.contactNameBool = true;
          }
          else if(this.templateArray.filter(x => x.includes('NoShow out_display_name')).length)
          {
              this.contactNameN=true;
          }
          this.salesTypeDescription = this.endUserModel.salesTypeDescription;
          this.salesTypeDescriptionFilter = this.salesTypeDescription;
          this.templateArray.forEach((tem, idx) => {
            if (!tem.includes('end-user-validator')) {
              this.templateArray = this.templateArray.filter(x => x !== tem);
              this.salesTypeDescriptionFilter = this.salesTypeDescriptionFilter.filter(x => x !== this.salesTypeDescription[idx]);
              this.salesTypeArrayFilter = this.salesTypeArrayFilter.filter(x => x !== this.salesTypeArray[idx]);
            }
          });
          if (this.templateArray.filter(x => x.includes('required out_company_name'))|| this.templateArray.filter(x => x.includes('optional out_company_name'))||this.templateArray.filter(x => x.includes('NoShow out_company_name')).length)
            {           
          // this.companyNameBool || this.addressBool || this.suburbBool || this.stateBool || this.postcodeBool || this.phoneBool || this.emailBool || this.countryBool
          //if (this.companyNameBool || this.addressBool || this.suburbBool || this.stateBool || this.postcodeBool || this.phoneBool || this.emailBool || this.countryBool||this.contactNameBool) {
            //this.showEndUserTab = true;
            this.loadContent = true
            if (this.endUserModel.cartEndUser) {
              if (!this.addressIsEdited) {
                //if (this.companyNameBool) this.addressFormGroup.get('out_company_name').setValue(this.endUserModel.cartEndUser.outCompanyName);
                 this.addressFormGroup.get('out_company_name').setValue(this.endUserModel.cartEndUser.outCompanyName);
                 this.addressFormGroup.get('out_address_1').setValue(this.endUserModel.cartEndUser.outAddress1);
                 this.addressFormGroup.get('out_address_2').setValue(this.endUserModel.cartEndUser.outAddress2);
                 this.addressFormGroup.get('out_address_3').setValue(this.endUserModel.cartEndUser.outAddress3);
                 this.addressFormGroup.get('out_suburb').setValue(this.endUserModel.cartEndUser.outSuburb);
                 this.addressFormGroup.get('out_state').setValue(this.endUserModel.cartEndUser.outState);
                 this.addressFormGroup.get('out_postcode').setValue(this.endUserModel.cartEndUser.outPostcode);
                 this.addressFormGroup.get('out_phone').setValue(this.endUserModel.cartEndUser.outPhone);
                 this.addressFormGroup.get('out_country').setValue(this.endUserModel.cartEndUser.outCountry);
                 this.addressFormGroup.get('out_email').setValue(this.endUserModel.cartEndUser.outEmail);
                 this.addressFormGroup.get('out_display_name').setValue(this.endUserModel.cartEndUser.outDisplayName);
              }
             }
             
           // }

          } else {
            if (!this.salesTypeArrayFilter.length) {
              this.loadContent = true;
              this.checkOutService.skipEndUserStep$.next(true);
              if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
                this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
              } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
                // this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                if (this.currentUserModel.isAU) {
                  this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                } else {
                  this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                }
              } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
                this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
              }
            } else {
              this.loadContent = false;
              $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex');
              setTimeout(() => { $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex'); this.showEndUserTab = false; this.loadContent = true; }, 1000)
            }

          }

        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    });

    // this.activatedRoute.parent.parent.paramMap.takeUntil(this.ngUnsubscribe).subscribe((params) => {
    //   this.serial = params.get('serial');
    // })

    this.activatedRoute.parent.parent.parent.paramMap.pipe(
      switchMap((params) => {
        return this.activatedRoute.parent.parent.paramMap.pipe(
          map((param) => {
            return {
              quoteId: params.get('sku'),
              serial: param.get('serial'),
            }
          })
        )
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.quoteId = res.quoteId;
      this.serial = res.serial;
      if (this.quoteId) {
        this.backto = 'quote';
      } else if (this.serial) {
        this.backto = 'renewal';
      } else {
        this.backto = 'cart';
      }
    })

  }


  switchShipInfo(ob: MatSlideToggleChange): void {
    if (ob.checked) {
      // if (this.shippingAddressModel.collectTheOrder) {
      //   this.addressFormGroup.get('out_company_name').setValue(this.shippingAddressModel.warehouseAddress);
      //   this.addressFormGroup.get('out_address_1').setValue('');
      //   this.addressFormGroup.get('out_address_2').setValue('');
      //   this.addressFormGroup.get('out_address_3').setValue('');
      //   this.addressFormGroup.get('out_suburb').setValue('');
      //   this.addressFormGroup.get('out_state').setValue('');
      //   this.addressFormGroup.get('out_postcode').setValue('');
      //   this.addressFormGroup.get('out_phone').setValue('');
      // } else {
        this.addressFormGroup.get('out_company_name').setValue(this.shippingAddressModel.addressGroup.companyName);
        this.addressFormGroup.get('out_address_1').setValue(this.shippingAddressModel.addressGroup.addressLine1);
        this.addressFormGroup.get('out_address_2').setValue(this.shippingAddressModel.addressGroup.addressLine2);
        this.addressFormGroup.get('out_address_3').setValue(this.shippingAddressModel.addressGroup.addressLine3);
        this.addressFormGroup.get('out_suburb').setValue(this.shippingAddressModel.addressGroup.suburb);
        this.addressFormGroup.get('out_state').setValue(this.shippingAddressModel.addressGroup.state);
        this.addressFormGroup.get('out_postcode').setValue(this.shippingAddressModel.addressGroup.postcode);
        this.addressFormGroup.get('out_phone').setValue(this.shippingAddressModel.addressGroup.phone);
      // }
    } else {
      if (this.endUserModel.cartEndUser) {
        this.addressFormGroup.get('out_company_name').setValue(this.endUserModel.cartEndUser.outCompanyName);
        this.addressFormGroup.get('out_address_1').setValue(this.endUserModel.cartEndUser.outAddress1);
        this.addressFormGroup.get('out_address_2').setValue(this.endUserModel.cartEndUser.outAddress2);
        this.addressFormGroup.get('out_address_3').setValue(this.endUserModel.cartEndUser.outAddress3);
        this.addressFormGroup.get('out_suburb').setValue(this.endUserModel.cartEndUser.outSuburb);
        this.addressFormGroup.get('out_state').setValue(this.endUserModel.cartEndUser.outState);
        this.addressFormGroup.get('out_postcode').setValue(this.endUserModel.cartEndUser.outPostcode);
        this.addressFormGroup.get('out_phone').setValue(this.endUserModel.cartEndUser.outPhone);
        // this.addressFormGroup.get("out_country").setValue(this.endUserModel.cartEndUser.outCountry);
        this.addressFormGroup.get('out_email').setValue(this.endUserModel.cartEndUser.outEmail);
      } else {
        this.addressFormGroup.get('out_company_name').setValue('');
        this.addressFormGroup.get('out_address_1').setValue('');
        this.addressFormGroup.get('out_address_2').setValue('');
        this.addressFormGroup.get('out_address_3').setValue('');
        this.addressFormGroup.get('out_suburb').setValue('');
        this.addressFormGroup.get('out_state').setValue('');
        this.addressFormGroup.get('out_postcode').setValue('');
        this.addressFormGroup.get('out_phone').setValue('');
      }
    }
  }

  nextSalesType(salesType: string) {
  
    let result = true;

    if ($('#' + salesType).find($('.required .out_display_name'))) {
      //$('#' + salesType).append(`<input type="hidden" name="${salesType}_out_display_name" value="${this.addressFormGroup.get('out_display_name').value}" />`);
      if ($(`input[name=${salesType}_out_display_name]`).length == 0) {
        $('#' + salesType).append(`<input type="hidden" name="${salesType}_out_display_name" value="${this.addressFormGroup.get('out_display_name').value}" />`);
      }
    }

    this.ngProgress.start();

    if ($('#' + salesType).length > 0) {
      $('#' + salesType + ' .form-row input.required').each(function () {
        if ($.trim($(this).val()).length == 0) {
          result = false;
          $(this).showValidator('This field must be filled', 'error', 'right');
        }
      });
    }

    if (result) {
      this.loadSalesType = this.loadContent = false;

      const formElement: HTMLFormElement = document.querySelector('#' + salesType) as HTMLFormElement;

      const data = new FormData(formElement);

      fetch('api/checkout/SetEndUserDetailPost?cartId=' + this.cartId, {
        method: 'POST',
        body: data
        // body: $('#' + salesType).serialize()
      }).then(res => {
        if (res.ok) {

          this.loadSalesType = this.loadContent = true;

          if (this.salesTypeArrayFilter.length > 3) {
            this.checkOutService.monitorXscroll(true);
          }
          if (this.salesTypeArrayFilter.length - 1 > this.salesTypeArrayFilter.indexOf(salesType)) {
            $('#' + this.salesTypeArrayFilter[this.salesTypeArrayFilter.indexOf(salesType) + 1] + '_content').css('display', 'flex');
            this.ngProgress.done();
          } else {
            this.checkOutService.monitorXscroll(false);
            if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
              this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
            } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
              // NZ site is not using donation page
              // if (this.currentUserModel.isAU) {
              //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
              // } else {
                this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
              // }
            } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
              this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
            }
          }
        }
      }).catch(() => {
        this.loadSalesType = this.loadContent = false;
      });

    }



    //const response = await goNext(this.cartId, salesType);
    // if (response && response.status) {

    //   if (this.salesTypeArrayFilter.length > 3) {
    //     this.checkOutService.monitorXscroll(true);
    //   }
    //   if (this.salesTypeArrayFilter.length - 1 > this.salesTypeArrayFilter.indexOf(salesType)) {
    //     $('#' + this.salesTypeArrayFilter[this.salesTypeArrayFilter.indexOf(salesType) + 1] + '_content').css('display', 'flex');
    //     this.ngProgress.done();
    //   } else {
    //     this.checkOutService.monitorXscroll(false);
    //     if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
    //       this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
    //     } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
    //       // NZ site is not using donation page
    //       if (this.currentUserModel.isAU) {
    //         this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
    //       } else {
    //         this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
    //       }
    //     } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
    //       this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
    //     }
    //   }
    // }

  }

  // copyAllBrands(): void {
  //   let part = this.el.nativeElement.querySelector('.tab-pane.active .btnCopyAllBrands');
  //   if (part) {
  //     this.renderer.listen(part, "click", function () {
  //       if (!$('.tab-pane.active .btnCopyAllBrands').attr('checked')) {
  //         $('.tab-pane.active .btnCopyAllBrands').attr('checked', 'true');
  //       } else {
  //         $('.tab-pane.active .btnCopyAllBrands').removeAttr('checked');
  //       }
  //       copyBrands($('.tab-pane.active .btnCopyAllBrands').attr('checked'));
  //     });
  //   }
  // }

  // openPopup(): void {
  //   this.el.nativeElement.querySelector('.tab-pane.active .endUserAdressBookBtn').addEventListener('click', this.openSelectEndUserPage.bind(this));
  // }

  openSelectEndUserPage(): void {
    this.router.navigate(['end-user/selectenduser'], { relativeTo: this.activatedRoute.parent });
  }

  closeEndUserAddrBook(): void {
    closeAddrBook();
  }

  goPrevious(): void {
    $('.reveal-overlay').remove();
  }


  nextPage(): void {
   
    if (this.showEndUserTab) {
      if (this.addressFormGroup.valid) {
        let flag = false;
        if (this.postcodeBool) {
          if (this.addressFormGroup.get('out_postcode').value.length < 4) {
            flag = true;
            this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
          }
        }
        // if (this.addressFormGroup.get('out_postcode').value.length < 4 && this.postcodeBool) {
        //   flag = true;
        //   this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
        // }
        if (!flag) {
          this.loadContent = false;
          let inputModel = {} as any;
          //if (this.companyNameBool) inputModel.out_company_name = encodeURIComponent(this.addressFormGroup.get('out_company_name').value);
           inputModel.out_company_name = encodeURIComponent(this.addressFormGroup.get('out_company_name').value || "");
           inputModel.out_address_1 = encodeURIComponent(this.addressFormGroup.get('out_address_1').value || "");
           inputModel.out_address_2 = encodeURIComponent(this.addressFormGroup.get('out_address_2').value || "");
           inputModel.out_address_3 = encodeURIComponent(this.addressFormGroup.get('out_address_3').value || "");
           inputModel.out_email = encodeURIComponent(this.addressFormGroup.get('out_email').value || "");
           inputModel.out_country = encodeURIComponent(this.addressFormGroup.get('out_country').value || "");
           inputModel.out_suburb = this.addressFormGroup.get('out_suburb').value || "";
           inputModel.out_state = this.addressFormGroup.get('out_state').value || "";
           inputModel.out_postcode = this.addressFormGroup.get('out_postcode').value || "";
           inputModel.out_phone = this.addressFormGroup.get('out_phone').value|| "";
           inputModel.out_display_name = encodeURIComponent(this.addressFormGroup.get('out_display_name').value || "");
          // inputModel = {
          //   out_company_name: encodeURIComponent(this.addressFormGroup.get('out_company_name').value),
          //   out_address_1: encodeURIComponent(this.addressFormGroup.get('out_address_1').value),
          //   out_address_2: encodeURIComponent(this.addressFormGroup.get('out_address_2').value),
          //   out_address_3: encodeURIComponent(this.addressFormGroup.get('out_address_3').value),
          //   out_email: encodeURIComponent(this.addressFormGroup.get('out_email').value),
          //   out_country: encodeURIComponent(this.addressFormGroup.get('out_country').value),
          //   out_suburb: this.addressFormGroup.get('out_suburb').value,
          //   out_state: this.addressFormGroup.get('out_state').value,
          //   out_postcode: this.addressFormGroup.get('out_postcode').value,
          //   out_phone: this.addressFormGroup.get('out_phone').value
          // };
          this.checkOutService.SetEndUserDetail(JSON.stringify(inputModel), this.commonService.toNumber(this.cartId)).subscribe((res: ApiResponse) => {
            if (res.status) {
              if (!this.salesTypeArrayFilter.length) {
                this.loadContent = true;

                // if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
                //   this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
                // } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
                //   // this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                // } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
                //   this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
                // }

                if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
                  this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
                } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
                  // NZ site is not using donation page
                  // if (this.currentUserModel.isAU) {
                  //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                  // } else {
                    this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                  // }
                } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
                  this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
                }

              } else {
                $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex');
                this.loadContent = true;
              }
            } else {
              this.loadContent = true;
              this.commonService.showError('.endusernext', res.responseMessage, 'right');
            }
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        }
      } else {
        this.isNotValidField('out_company_name', this.account_validation_messages.out_company_name);
        this.isNotValidField('out_address_1', this.account_validation_messages.out_address_1);
        this.isNotValidField('out_suburb', this.account_validation_messages.out_suburb);
        this.isNotValidField('out_state', this.account_validation_messages.out_state);
        this.isNotValidField('out_postcode', this.account_validation_messages.out_postcode);
        this.isNotValidField('out_phone', this.account_validation_messages.out_phone);
        this.isNotValidField('out_email', this.account_validation_messages.out_email);
        this.isNotValidField('out_country', this.account_validation_messages.out_country);
        this.isNotValidField('out_display_name', this.account_validation_messages.out_display_name);
      }

    } else {

      if (!this.salesTypeArrayFilter.length) {
        this.loadContent = true;

        if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
          this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
        } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
          // NZ site is not using donation page
          // if (this.currentUserModel.isAU) {
          //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
          // } else {
            this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
          // }
        } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
          this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
        }

        // if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
        //   this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
        // } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
        //   // this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
        //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
        // } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
        //   this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
        // }
        
      } else {
        $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex');
        this.loadContent = true;
      }
    }

  }

  // nextPage(): void {
  //   if (this.showEndUserTab) {
  //   }
  //   if (this.addressFormGroup.valid) {
  //     let flag = false;
  //     if (this.addressFormGroup.get('out_postcode').value.length < 4 && this.postcodeBool) {
  //       flag = true;
  //       this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
  //     }
  //     if (!flag) {
  //       this.loadContent = false;
  //       let inputModel = {} as any;
  //       inputModel = {
  //         out_company_name: encodeURIComponent(this.addressFormGroup.get('out_company_name').value),
  //         out_address_1: encodeURIComponent(this.addressFormGroup.get('out_address_1').value),
  //         out_address_2: encodeURIComponent(this.addressFormGroup.get('out_address_2').value),
  //         out_address_3: encodeURIComponent(this.addressFormGroup.get('out_address_3').value),
  //         out_email: encodeURIComponent(this.addressFormGroup.get('out_email').value),
  //         out_country: encodeURIComponent(this.addressFormGroup.get('out_country').value),
  //         out_suburb: this.addressFormGroup.get('out_suburb').value,
  //         out_state: this.addressFormGroup.get('out_state').value,
  //         out_postcode: this.addressFormGroup.get('out_postcode').value,
  //         out_phone: this.addressFormGroup.get('out_phone').value
  //       };
  //       this.checkOutService.SetEndUserDetail(JSON.stringify(inputModel), toNumber(this.cartId)).subscribe((res: ApiResponse) => {
  //         if (res.status) {
  //           this.checkOutService.GetEndUser(toNumber(this.cartId), this.checkoutViewModel.firstStep, this.checkoutViewModel.kitProgramTypeList).takeUntil(this.ngUnsubscribe).subscribe((getEndUser: EndUserModel) => {
  //             this.endUserModel = getEndUser;
  //             this.salesTypeArray = this.endUserModel.salesTypeTab;
  //             this.salesTypeArrayFilter = this.salesTypeArray;
  //             this.templateArray = this.endUserModel.endUserTemplate;
  //             if (this.templateArray.filter(x => x.includes('required out_company_name')).length) {
  //               this.companyNameBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_address_1')).length) {
  //               this.addressBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_suburb')).length) {
  //               this.suburbBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_state')).length) {
  //               this.stateBool = true;
  //               this.statePlaceHolder = 'State *';
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_postcode')).length) {
  //               this.postcodeBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_phone')).length) {
  //               this.phoneBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_email')).length) {
  //               this.emailBool = true;
  //             }
  //             if (this.templateArray.filter(x => x.includes('required out_country')).length) {
  //               this.countryBool = true;
  //             }


  //             this.salesTypeDescription = this.endUserModel.salesTypeDescription;
  //             this.salesTypeDescriptionFilter = this.salesTypeDescription;
  //             this.templateArray.forEach((tem, idx) => {
  //               if (!tem.includes('end-user-validator')) {
  //                 this.salesTypeDescriptionFilter = this.salesTypeDescriptionFilter.filter(x => x !== this.salesTypeDescription[idx]);
  //                 this.salesTypeArrayFilter = this.salesTypeArrayFilter.filter(x => x !== this.salesTypeArray[idx]);
  //               }
  //             });
  //             if (this.endUserModel.cartEndUser) {
  //               // if (this.endUserModel.cartEndUser.outCountry) {
  //               //   this.countryBool = true;
  //               // }
  //               if (!this.addressIsEdited) {
  //                 this.addressFormGroup.get('out_company_name').setValue(this.endUserModel.cartEndUser.outCompanyName);
  //                 this.addressFormGroup.get('out_address_1').setValue(this.endUserModel.cartEndUser.outAddress1);
  //                 this.addressFormGroup.get('out_address_2').setValue(this.endUserModel.cartEndUser.outAddress2);
  //                 this.addressFormGroup.get('out_address_3').setValue(this.endUserModel.cartEndUser.outAddress3);
  //                 this.addressFormGroup.get('out_suburb').setValue(this.endUserModel.cartEndUser.outSuburb);
  //                 this.addressFormGroup.get('out_state').setValue(this.endUserModel.cartEndUser.outState);
  //                 this.addressFormGroup.get('out_postcode').setValue(this.endUserModel.cartEndUser.outPostcode);
  //                 this.addressFormGroup.get('out_phone').setValue(this.endUserModel.cartEndUser.outPhone);
  //                 this.addressFormGroup.get('out_country').setValue(this.endUserModel.cartEndUser.outCountry);
  //                 this.addressFormGroup.get('out_email').setValue(this.endUserModel.cartEndUser.outEmail);
  //               }
  //             }

  //             if (!this.salesTypeArrayFilter.length) {
  //               this.loadContent = true;
  //               if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
  //                 this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
  //               } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
  //                 // this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
  //                 this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
  //               } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
  //                 this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
  //               }
  //             } else {
  //               $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex');
  //               this.loadContent = true;
  //             }

  //             // if(this.endUserModel.endUserTemplate){
  //             //   setTimeout(() => {
  //             //     // this.copyShipInfo(this.shippingAddressModel);
  //             //     // this.copyAllBrands();
  //             //     // this.openPopup();
  //             //   }, 1000);
  //             // }
  //           },
  //             (error: any) => {
  //               console.error(error);
  //               this.loadContent = true;
  //             });



  //           // if (!this.salesTypeArrayFilter.length) {
  //           //   this.loadContent = true;
  //           //   if (this.checkoutViewModel.tenantDetailsRequired === 'YES') {
  //           //     this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
  //           //   } else if (((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
  //           //     this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
  //           //   } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
  //           //     this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
  //           //   }
  //           // } else {
  //           //   $('#' + this.salesTypeArrayFilter[0] + '_content').css('display', 'flex');
  //           //   this.loadContent = true;
  //           // }

  //         } else {
  //           this.loadContent = true;
  //           this.commonService.showError('.endusernext', res.responseMessage, 'right');
  //         }
  //       },
  //         (error: any) => {
  //           console.error(error);
  //           this.loadContent = true;
  //         });
  //     }
  //   } else {
  //     this.isNotValidField('out_company_name', this.account_validation_messages.out_company_name);
  //     this.isNotValidField('out_address_1', this.account_validation_messages.out_address_1);
  //     this.isNotValidField('out_suburb', this.account_validation_messages.out_suburb);
  //     this.isNotValidField('out_state', this.account_validation_messages.out_state);
  //     this.isNotValidField('out_postcode', this.account_validation_messages.out_postcode);
  //     this.isNotValidField('out_phone', this.account_validation_messages.out_phone);
  //     this.isNotValidField('out_email', this.account_validation_messages.out_email);
  //     this.isNotValidField('out_country', this.account_validation_messages.out_country);
  //   }
  // }

  chooseAutoComplete(option: PostcodeList): void {
    this.addressFormGroup.get('out_postcode').setValue(option.postcode);
    this.addressFormGroup.get('out_state').setValue(option.state);
    this.addressFormGroup.get('out_suburb').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCodeFromAPI) {
      this.addressFormGroup.get('out_postcode').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.addressFormGroup.get('out_state').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.addressFormGroup.get('out_suburb').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSubFromAPI) {
      this.addressFormGroup.get('out_postcode').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.addressFormGroup.get('out_state').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.addressFormGroup.get('out_suburb').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  startFilterSub(): void {
    if (this.addressFormGroup.get('out_suburb').value.length > 2) {
      var postCodeSearchKey = ''; 
      this.authService.GetPostCodeList(this.addressFormGroup.get('out_suburb').value, postCodeSearchKey).subscribe((res: PostcodeList[]) => {
        this.filteredSubFromAPI = res;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  startFilterPostcode(): void {
    if (this.addressFormGroup.get('out_postcode').value.length > 1) {
      var suburbSearchKey = ''; 
      this.authService.GetPostCodeList(suburbSearchKey, this.addressFormGroup.get('out_postcode').value).subscribe((res: PostcodeList[]) => {
        this.filteredPostCodeFromAPI = res;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  closeSalesType(salesType: string, index: number): void {

    if (this.showEndUserTab) {
      $('#' + salesType + '_content').css('display', 'none');
    } else {
      if (index == 0) {
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
      } else {
        $('#' + salesType + '_content').css('display', 'none');
      }
    }

  }

  isNotValidField(path: string, validation: any): void {
    if (path === 'out_email') {
      if (this.addressFormGroup.get(path).hasError('required')) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      } else if (!this.addressFormGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, 'Please enter a valid email address', 'right', 'error');
      }
    } else {
      if (!this.addressFormGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      }
    }
  }

  clearAllFields(): void {
    this.addressFormGroup.reset();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  backtoCart() {
    this.checkOutService.monitorShowCartSummary('show');
    this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
  }

  backtoRenewals() {
    this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});
    //this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
  }

  backtoQuotes() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    $('.combination-loader').animate(
      { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

  }
  
  close() {
    // this.checkoutStatus = {
    //   currentStep: '',
    //   firstStep: '',
    //   hasChosenCheckout: false,
    //   collectOrder: false,
    //   tenantDetailsRequired: ''
    // };
    // this.checkOutService.emitChange(this.checkoutStatus);
    // this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });

  }
  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.addressFormGroup.get('out_address_1').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.addressFormGroup.get('out_address_2').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.addressFormGroup.get('out_address_3').setValue(event.target.value);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
